import can from './can'
export default function gate(param) {
    //TODO: permission not working
    return async({ next, from, store }) => {

        const isLogin = await store.state.auth.isLoggedIn

        if (!isLogin) return next('/login')
        if (can(param, store)) next()
        else next(from.fullPath)

    }




}